import { Modal } from 'antd'
import { useEffect, useState } from 'react'
import { EditAccessory } from './edit-accessory'
import { EditEmail } from './edit-email'
import { EditPhishing } from './edit-phishing'
import Scrollbars from 'react-custom-scrollbars'
import styled from 'styled-components'
import { SignTitle } from '@/components'
import { useGetDetail, useGetPhishDetail, useGetAttachmentDetail } from './utils'
import { t } from '@/i18n'
interface Template {
  isModalVisible: any
  handleCancel: (data: boolean) => void
}
export const EditTemplate = (props: Template) => {
  const { isModalVisible, handleCancel } = props
  let [particulars, setParticulars] = useState<any>()
  const [getDetail] = useGetDetail()
  const [getPhishDetail] = useGetPhishDetail()
  const [getAttachmentDetail] = useGetAttachmentDetail()
  let [selectTab, setSelectTab] = useState<'email' | 'phishing' | 'accessory' | ''>('email')
  const tabClickHanlder = (name: 'email' | 'phishing' | 'accessory' | '') => () => {
    setSubmit({ accomplish: false, timestamp: new Date().getTime() })
    setSelectTab(name)
  }
  const acquire = () => {
    handleCancel(true)
    setSubmit({ accomplish: false, timestamp: new Date().getTime() })
    setSelectTab('')
    setParticulars([])
  }
  const [submit, setSubmit] = useState({ accomplish: false, timestamp: null })
  useEffect(() => {
    if (isModalVisible.type === 1) {
      tabClickHanlder('email')()
      getDetail({ id: isModalVisible.id })
        .then(res => {
          setParticulars((particulars = res.data))
        })
        .catch(err => {})
    }
    if (isModalVisible.type === 2) {
      tabClickHanlder('phishing')()
      getPhishDetail({ id: isModalVisible.id })
        .then(res => {
          setParticulars((particulars = res.data))
        })
        .catch(err => {})
    }
    if (isModalVisible.type === 3) {
      tabClickHanlder('accessory')()
      getAttachmentDetail({ id: isModalVisible.id })
        .then(res => {
          setParticulars((particulars = res.data))
        })
        .catch(err => {})
    }
  }, [isModalVisible])
  return (
    <Create
      title={
        <>
          {isModalVisible?.type === 1 && (
            <SignTitle show>
              {t('编辑')}
              {isModalVisible?.origin_type === 3 ? 'AI' : '自定义'}
              {t('邮件模板')}
            </SignTitle>
          )}
          {isModalVisible?.type === 2 && (
            <SignTitle show>
              {t('编辑')}
              {isModalVisible?.origin_type === 3 ? 'AI' : '自定义'}
              {t('钓鱼页模板')}
            </SignTitle>
          )}
          {isModalVisible?.type === 3 && <SignTitle show>{t('编辑自定义附件模板')}</SignTitle>}
        </>
      }
      visible={isModalVisible.visible}
      onOk={() => setSubmit({ accomplish: true, timestamp: new Date().getTime() })}
      onCancel={() => {
        tabClickHanlder('')()
        handleCancel(false)
        setParticulars((particulars = []))
        setSubmit({ accomplish: false, timestamp: new Date().getTime() })
      }}
      width={800}
      centered
    >
      <div style={{ width: '100%', height: '450px' }}>
        <Scrollbars>
          {selectTab === 'email' && particulars?.id && (
            <EditEmail
              particulars={particulars}
              submit={submit}
              id={isModalVisible.id}
              acquire={acquire}
            />
          )}
          {selectTab === 'phishing' && particulars?.id && (
            <EditPhishing
              particulars={particulars}
              submit={submit}
              acquire={acquire}
              id={isModalVisible.id}
            />
          )}
          {selectTab === 'accessory' && particulars?.id && (
            <EditAccessory
              particulars={particulars}
              submit={submit}
              acquire={acquire}
              id={isModalVisible.id}
            />
          )}
        </Scrollbars>
      </div>
    </Create>
  )
}
const Create = styled(Modal)`
  .header-table {
    width: 100%;
    display: flex;
    background-color: #f8f8f8;
    border-radius: 8px;
    margin-bottom: 18px;
    height: 32px;
    .tab-item {
      cursor: pointer;
      width: 100%;
      display: flex;
      justify-content: center;
      background-color: #efefef;
      align-items: center;
      margin-right: 4px;
      &:nth-child(1) {
        border-radius: 16px 0px 0px 16px;
      }
      &:nth-last-child(1) {
        border-radius: 0px 16px 16px 0px;
      }
    }
  }
  .ant-btn-primary {
    color: #fff !important;
  }
`
